<div *transloco="let t" class="w-screen h-screen bg-calm overflow-hidden open-sans" [ngClass]="{'animation-wrong': showAnimationWrong,'animation-timeout': showAnimationTimeout}">
    @if(showAnimationWrong){<div class="fixed z-[999999] top-[500px] w-screen text-center text-red-600 font-bold text-[120px]">{{t('noWrongBuzzer')}}</div>}
    @if(showAnimationTimeout){<div class="fixed z-[999999] top-[500px] w-screen text-center text-red-600 font-bold text-[120px]">{{t('timeoutBuzzer')}}</div>}
    @if(currentStep == -2){
    <div (click)="activateFullScreen()" class="font-bold cursor-pointer hover:underline size-10 text-[24px] fixed bottom-2 right-2">
        <svg fill="white" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M264 96L120 96C106.7 96 96 106.7 96 120L96 264C96 273.7 101.8 282.5 110.8 286.2C119.8 289.9 130.1 287.8 137 281L177 241L256 320L177 399L137 359C130.1 352.1 119.8 350.1 110.8 353.8C101.8 357.5 96 366.3 96 376L96 520C96 533.3 106.7 544 120 544L264 544C273.7 544 282.5 538.2 286.2 529.2C289.9 520.2 287.9 509.9 281 503L241 463L320 384L399 463L359 503C352.1 509.9 350.1 520.2 353.8 529.2C357.5 538.2 366.3 544 376 544L520 544C533.3 544 544 533.3 544 520L544 376C544 366.3 538.2 357.5 529.2 353.8C520.2 350.1 509.9 352.1 503 359L463 399L384 320L463 241L503 281C509.9 287.9 520.2 289.9 529.2 286.2C538.2 282.5 544 273.7 544 264L544 120C544 106.7 533.3 96 520 96L376 96C366.3 96 357.5 101.8 353.8 110.8C350.1 119.8 352.2 130.1 359 137L399 177L320 256L241 177L281 137C287.9 130.1 289.9 119.8 286.2 110.8C282.5 101.8 273.7 96 264 96z" />
        </svg>
    </div><a class="font-bold hover:underline size-10 text-[24px] fixed bottom-2 right-[50px]" target="_blank"
        [href]="'/moderation/'+ idLive"><svg fill="white" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M256.1 312C322.4 312 376.1 258.3 376.1 192C376.1 125.7 322.4 72 256.1 72C189.8 72 136.1 125.7 136.1 192C136.1 258.3 189.8 312 256.1 312zM226.4 368C127.9 368 48.1 447.8 48.1 546.3C48.1 562.7 61.4 576 77.8 576L274.3 576L285.2 521.5C289.5 499.8 300.2 479.9 315.8 464.3L383.1 397C355.1 378.7 321.7 368.1 285.7 368.1L226.3 368.1zM332.3 530.9L320.4 590.5C320.2 591.4 320.1 592.4 320.1 593.4C320.1 601.4 326.6 608 334.7 608C335.7 608 336.6 607.9 337.6 607.7L397.2 595.8C409.6 593.3 421 587.2 429.9 578.3L548.8 459.4L468.8 379.4L349.9 498.3C341 507.2 334.9 518.6 332.4 531zM600.1 407.9C622.2 385.8 622.2 350 600.1 327.9C578 305.8 542.2 305.8 520.1 327.9L491.3 356.7L571.3 436.7L600.1 407.9z" />
        </svg>
    </a>}
    @if(currentStep == -2){<div class="w-fit mx-auto text-live_primary pt-20 text-[20px] flex items-center gap-2.5 font-semibold">
        {{t('joinLiveLink')}} <a class="font-bold underline text-[24px]" target="_blank"
            [href]="'/live/'+ idLive">{{origin+'/live/'+ idLive}}</a></div>
    <div class="text-center text-live_primary font-semibold">{{t('auth.or')}}</div>
    <div class="text-center font-[800] text-[26px] text-live_primary">{{t('scanQRCode')}}</div>
}
    @if(idLive && currentStep == -2){<div class="flex flex-wrap gap-6 mx-auto mt-10 w-fit items-center">
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[0]}}</div>
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[1]}}</div>
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[2]}}</div>
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[3]}}</div>
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[4]}}</div>
        <div
            class="h-24 w-[60px] bg-white bg-opacity-30 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[5]}}</div>

    </div>}
    @if(qrCode && idLive && currentStep == -2){<div class="size-[200px] mx-auto mt-10 rounded-md overflow-hidden">
        <qrcode [qrdata]="'http://'+qrCode" [width]="200"></qrcode>
        <!-- <qrcode [qrdata]="'http://192.168.1.22:4200/live/' + idLive" [width]="200"></qrcode> -->
    </div>}
    @if(currentStep == -2){<div class="flex flex-wrap gap-5 px-10 place-content-center items-start h-fit mt-10">
        @for (user of users; track $index) {
        <div [style.background]="user.color ?? 'rgba(255, 255, 255 ,0.25)'" style="transition-duration: 250ms;"
            class="pl-2 pr-4 rounded-full border-black backdrop-blur-[50px]">
            <div class="flex gap-2 items-center">
                <div class="text-[40px]">{{user?.profile_icon}}</div>
                <div class="text-white font-bold text-[24px]">{{user?.nickname}}</div>
            </div>
        </div>
        }
    </div>}
    @if(currentStep >= 0 && showTimer && !endedTimeQuestion){<div
        class="fixed cursor-pointer left-2 bottom-2 size-[50px] z-20 bg-white flex gap-5 rounded-lg place-content-center">
        @if(barTimeStopped){<svg (click)="startBarTimer()" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z" />
        </svg>}
        @if(!barTimeStopped){<svg (click)="stopBarTimer()" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M176 96C149.5 96 128 117.5 128 144L128 496C128 522.5 149.5 544 176 544L240 544C266.5 544 288 522.5 288 496L288 144C288 117.5 266.5 96 240 96L176 96zM400 96C373.5 96 352 117.5 352 144L352 496C352 522.5 373.5 544 400 544L464 544C490.5 544 512 522.5 512 496L512 144C512 117.5 490.5 96 464 96L400 96z" />
        </svg>}
    </div>

    <div (click)="!barTimeStopped ? stopBarTimer() : null;endQuestion();currentAudio?.pause()"
        class="fixed cursor-pointer left-[70px] bottom-2 size-[50px] z-20 bg-white flex gap-5 rounded-lg place-content-center">
        <svg xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
            <path
                d="M535.1 342.6C547.6 330.1 547.6 309.8 535.1 297.3L375.1 137.3C362.6 124.8 342.3 124.8 329.8 137.3C317.3 149.8 317.3 170.1 329.8 182.6L467.2 320L329.9 457.4C317.4 469.9 317.4 490.2 329.9 502.7C342.4 515.2 362.7 515.2 375.2 502.7L535.2 342.7zM183.1 502.6L343.1 342.6C355.6 330.1 355.6 309.8 343.1 297.3L183.1 137.3C170.6 124.8 150.3 124.8 137.8 137.3C125.3 149.8 125.3 170.1 137.8 182.6L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7z" />
        </svg>
    </div>
    }
    @if(users.length == 0){
    <div class="text-live_primary font-semibold text-[24px] mt-12 w-screen">
        <div class="text-center">{{t('needPlayer')}}</div>
        <div class="text-center">{{t('noPlayer')}}</div>
    </div>
    }
    @if(users.length > 0 && currentStep == -2){
    <div class="fixed bottom-12 left-0 w-screen">
        <div (click)="startQuiz()"
            class="mx-auto rounded-full text-[48px] font-medium w-[275px] bg-live_primary uppercase text-white flex items-center place-content-center cursor-pointer">
            {{t('start')}}</div>
    </div>
    }
    @if(currentStep == -1){
    <div class="h-[100dvh] w-screen flex items-center place-content-center">
        <div class="size-[200px] flex place-content-center items-center rounded-full border-[10px] border-white text-white font-bold text-[70px] animate-ping"
            id="timer-start">
            {{timerStart}}
        </div>
    </div>
    }
    @if(currentStep >= 0 && !endQuiz){
        <div class="bg-live_primary pt-12 pb-6 rounded-b-[28px] mb-4 text-[18px] font-bold">
    <div class="text-[34px] text-center text-live_secondary font-bold px-5">{{quiz.questions[currentStep].title}}</div>
    @if(quiz.questions[currentStep].type == 1){
    <div class="text-live_secondary text-center mt-2 px-5">{{t('multipleExplanation')}}</div>
    }
    @if(quiz.questions[currentStep].type == 2){<div class="text-live_secondary text-center mt-2 px-5">{{t('buzzerExplanation')}}
    </div>}
    @if(quiz.questions[currentStep].type == 3){<div class="text-live_secondary text-center mt-2 px-5">{{t('mapExplanation')}}
    </div>}
    @if(quiz.questions[currentStep].type == 4){<div class="text-live_secondary text-center mt-2 px-5">{{t('numberExplanation')}}
    </div>}</div>
    @if(quiz.questions[currentStep].type == 2 && reservedUser){
    <div class="w-fit mt-20 mx-auto p-3 place-content-center items-start h-fit border-white border-2 rounded-2xl">
        <div class="text-center font-bold text-[22px] text-white pb-2.5">{{t('reservedUser')}}</div>
        <div [style.background]="'rgba(255, 255, 255 ,0.25)'" style="transition-duration: 250ms;"
            class="px-2 rounded-full mx-auto w-fit border-black backdrop-blur-[50px]">
            <div class="flex gap-2 items-center">
                <div class="text-[40px]">{{reservedUser?.profile_icon}}</div>
                <div class="text-white font-bold text-[24px]">{{reservedUser?.nickname}}</div>
            </div>
        </div>
    </div>
    }
    @if(quiz.questions[currentStep].type && !endQuiz && !showRank){
    <div class="text-[32px] pt-2 text-white font-bold px-5 text-center mx-auto">{{t('totalAnswered')}}
        {{totalAnswered}}/{{users.length}}</div>
    }
    @if(quiz.questions[currentStep].type == 4 && !endQuiz){
    <div style="animation-duration: 1500ms;"
        class="w-[90%] relative transition-all mt-20 mx-auto flex items-center h-10 border-white">
        <div class="h-10 w-[7px] bg-white rounded-full"></div>
        @if(endedTimeQuestion){
        <div style="place-items: anchor-center;"
            class="absolute z-[1] bottom-10 w-0 left-[0px] flex place-content-end text-white font-bold text-[32px]">
            <div>{{minNumber}}</div>
        </div>
        <div style="place-items: anchor-center;"
            class="absolute z-[1] bottom-10 w-0 right-[-2px] text-white font-bold text-[32px]">
            <div>{{maxNumber}}</div>
        </div>
        }
        <div class="w-full h-[7px] bg-white relative">
            @for (answer of usersAnswers; track $index) {
            <div (mouseenter)="userToShow = $index" (mouseleave)="userToShow = -1" [id]="'numeric-answer-' + answer.userId" style="animation-duration: 1500ms;" [style.left]="answer.left"
                class="absolute transition-all bottom-3 h-[40px] w-[40px] cursor-default">
                @if($index == userToShow){<div class="w-0 place-content-center flex absolute left-5 top-[-50px] h-[40px]" [ngClass]="{'!top-[-60px]': answer.isBest}">
                    <div class="h-[40px] px-2 rounded-md w-fit bg-white text-[15px]">
                        <div class="text-center leading-[18px] font-bold">{{answer.nickname}}</div>
                    <div class="text-center leading-[18px] font-semibold text-gray-500">{{answer.answer}}</div></div>
                </div>
                <div class="size-3 bg-white left-[14px] top-[-16px] rotate-[45deg] absolute" [ngClass]="{'!top-[-26px]': answer.isBest}"></div>
                }
                <div
                    class="map-pin flex z-[1] animation-insert-pin-number place-content-center h-[40px] w-[40px] items-center mx-auto rounded-full !duration-500 text-[28px] relative top-0 left-0" [ngClass]="{'!bg-[#ffd22f] !size-[50px] !top-[-10px] !left-[-5px] !text-[31px] animation-number-best-user': answer.isBest}">
                    <span>{{answer.emoji}}</span>
                </div>
                <div [ngClass]="{'!opacity-0': !showCorrectAnswer}" style="animation-duration: 1000ms;line-height: 16px;" class="mt-4 opacity-100 transition-all  rounded-full mx-auto w-fit text-[12px] px-2 bg-gray-500 text-white font-semibold">{{answer.answer}}</div>
            </div>
            }
            @if(showCorrectAnswer){
            <div [id]="'numeric-answer-correct-number'" style="animation-duration: 1500ms;"
                class="absolute transition-all left-[0%] bottom-[-4px] z-10 h-fit w-[0px] flex place-content-center">
                <div class="w-fit">
                    <div
                        class="flex place-content-center py-1 w-fit px-3 items-center mx-auto bg-green-500 rounded-md text-[24px] text-white font-bold">
                        {{correctNumberAnswer}}</div>
                    <div class="w-[3px] mx-auto bg-green-500 h-[55px]"></div>
                    <div class="border-white border-[3px] mx-auto size-4 bg-green-500 rounded-full"></div>
                </div>
            </div>
            <div [id]="'numeric-answer-correct-number-bar'" style="animation-duration: 1500ms"
                class="absolute transition-all bottom-[1.5px] bg-green-500 h-[4px] w-[0%]">
            </div>
            }
        </div>
        <div class="h-10 w-[7px] bg-white rounded-full"></div>
    </div>
    }
    <!-- @if(quiz.questions[currentStep].type == 5){<div>{{t('multipleAnswers')}}</div>}
    @if(quiz.questions[currentStep].type == 6){<div>{{t('multipleAnswers')}}</div>} -->
    @if(quiz.questions[currentStep].type == 3){
        <div class="absolute size-0 overflow-hidden opacity-0">
            <google-map
            [center]="{lat:toFloat(quiz.questions[currentStep].correct_value.split(',')[0]),lng:toFloat(quiz.questions[currentStep].correct_value.split(',')[1])}"
            [height]="getH()" width="90vw" [zoom]="mapZoom2" [options]="mapOptions">
            <map-marker [options]="markerOptions"
                [position]="{lat:toFloat(quiz.questions[currentStep].correct_value.split(',')[0]),lng:toFloat(quiz.questions[currentStep].correct_value.split(',')[1])}">
            </map-marker>
        </google-map></div>
        }
    @if(showTimer){<div class="bg-live_secondary fixed bottom-20 w-[calc(100vw-240px)] rounded-full flex items-center p-1 h-12 left-[120px] z-20"><div id="timer-question" class="w-[calc(100vw-248px)] h-10 rounded-full overflow-hidden">
        <div class="w-[calc(100vw-248px)] rounded-full h-10 animated-bar-timer"></div>
    </div></div>}
    }
    @if(!endQuiz && endedTimeQuestion && !showCurrentTempRank){
    <div class="text-white font-bold text-center my-5 text-[20px]">
        {{winBuzzer && !everyoneAnswered ? t('winBuzzer') :''}}
        {{everyoneAnswered && !winBuzzer ? t('everyoneAnswered') : ''}}
        {{!everyoneAnswered && !winBuzzer ? t('finishTime') : ''}}
        <!-- {{showRank ? t('currentLeaderboard') : ''}} -->
    </div>
    @if(quiz.questions[currentStep].type == 1 || (quiz.questions[currentStep].type == 2) && !showCurrentTempRank){
    <div class="w-[calc(100%-20px)] place-content-center flex-wrap mx-auto pt-2.5 flex gap-5">
        @for (answer of quiz.questions[currentStep].question_options; track $index) {
        @if(answer.option_text){<div
            class="min-h-[68px] p-2 w-[200px] mb-1 text-live_secondary text-[22px] items-center place-content-center text-center rounded-[24px] font-bold bg-white transition-all"
            style="transform:scale(1);transform-origin: center;"
            [ngClass]="{'!bg-green-400 transform-1_2': answer.option_text == quiz.questions[currentStep].correct_value && showCorrectAnswer,'bg-red-600 transform-0_8': answer.option_text !== quiz.questions[currentStep].correct_value && showCorrectAnswer}">
            @if(answer.perc > 0 || quiz.questions[currentStep].type != 2){<div class="text-[20px] font-bold">{{answer.perc}}%</div>}
            <div>{{answer.option_text}}</div>
        </div>}
        }
    </div>
    }
    <div class="flex gap-x-24 pt-5 items-center place-content-center flex-wrap">
        
    @if(quiz.questions[currentStep].type == 3 && !showCurrentTempRank){
    <div class="w-screen"><div class="w-fit mx-auto rounded-[28px] overflow-hidden">
        <google-map
            [center]="{lat:toFloat(quiz.questions[currentStep].correct_value.split(',')[0]),lng:toFloat(quiz.questions[currentStep].correct_value.split(',')[1])}"
            [height]="getH()" width="90vw" [zoom]="mapZoom" [options]="mapOptions">
            <!-- <map-marker *ngIf="answerToQuestion"
                    [position]="{lat:toFloat(answerToQuestion.split(',')[0]),lng:toFloat(answerToQuestion.split(',')[1])}">
                </map-marker> -->
            <map-marker [options]="markerOptions"
                [position]="{lat:toFloat(quiz.questions[currentStep].correct_value.split(',')[0]),lng:toFloat(quiz.questions[currentStep].correct_value.split(',')[1])}">
            </map-marker>
            @for (answer of usersAnswers; track $index) {
            <map-marker [options]="getMarkerOptions(answer.profile_icon)" [position]="{lat:answer.lat,lng:answer.lng}">
            </map-marker>
            }
        </google-map></div></div>
    }@else{
    @if(!showCorrectAnswer){
    @if(!endQuiz){<div (click)="showCorrectQuestionAnswer()"
        class="text-live_secondary uppercase font-semibold mt-5 w-fit cursor-pointer text-center px-8 text-[22px] rounded-full py-2 bg-live_primary shadow-inner">
        {{t('showCorrectAnswer')}}
    </div>}
    }}
    
    @if(!quiz.questions[currentStep].question_settings.show_rank && showCorrectAnswer){<div (click)="nextQuestion()"
        class="text-live_primary font-bold mt-5 uppercase w-fit cursor-pointer text-center px-8 text-[22px] rounded-full py-2 bg-live_secondary shadow-inner">
        {{quiz.questions.length > (currentStep+1) ? t('nextQuestion') : t('terminateQuiz')}}</div>}
    @if(!showCurrentTempRank && quiz.questions.length > (currentStep+1) && quiz.questions[currentStep].question_settings.show_rank){
    <div (click)="showCurrentTempRank = true"
        class="text-live_primary font-bold mt-5 uppercase w-fit cursor-pointer text-center px-8 text-[22px] rounded-full py-2 bg-live_secondary shadow-inner">
        {{t('showRank')}}</div>
    }
    </div>
    }
    @if(showRank){
    <div class="px-10 border-b-live_secondary h-[calc(100svh-100px)]" [ngClass]="{'border-b-[12px]': !showCompleteRank}">
        @if(endQuiz && !showCompleteRank){<div class="flex gap-5 h-[calc(100svh-111px)] items-end mx-auto w-fit">
            <div class="w-screen top-[60px] fixed left-0 text-[60px] text-live_primary font-[900] text-center">Hall of Fame</div>
            @if(rankedUsers[1]?.users?.nickname){<div class="w-[250px]">
                <div class="flex gap-4 items-center place-content-center mb-2.5">
                    <div class="text-[42px] text-center">{{rankedUsers[1]?.users?.profile_icon}}</div>
                    <div class="text-white text-[24px] font-semibold text-center max-w-[200px] text-ellipsis overflow-hidden">
                        {{rankedUsers[1]?.users?.nickname}}</div>
                </div>
                <div class="w-[250px] podium-silver h-[30vh] flex items-end place-content-end bg-gray-400">
                    <div class="text-live_secondary font-bold text-[70px] leading-[38px] rounded-lg px-2 w-fit mx-auto text-center" [ngClass]="{'!text-[50px]':rankedUsers[1]?.score > 999,'!text-[30px]':rankedUsers[1]?.score > 99999}">
                        {{rankedUsers[1]?.score}}</div>
                </div>
            </div>}
            <div class="w-[250px]">
                <div class="flex gap-4 items-center place-content-center mb-2.5">
                    <div class="text-[42px] text-center">{{rankedUsers[0]?.users?.profile_icon}}</div>
                    <div class="text-white text-[24px] font-semibold text-center max-w-[200px] text-ellipsis overflow-hidden">
                        {{rankedUsers[0]?.users?.nickname}}</div>
                </div>
                <div class="w-[250px] flex place-content-center items-end leading-[38px] podium-gold h-[50vh] bg-yellow-400">
                    <div class="text-live_secondary font-bold text-[70px] rounded-lg px-2 w-fit mx-auto text-center" [ngClass]="{'!text-[50px]':rankedUsers[0]?.score > 999,'!text-[30px]':rankedUsers[0]?.score > 99999}">
                        {{rankedUsers[0]?.score}}</div>
                </div>
            </div>
            @if(rankedUsers[2]?.users?.nickname){
            <div class="w-[250px]">
                <div class="flex gap-4 items-center place-content-center mb-2.5">
                    <div class="text-[42px] text-center">{{rankedUsers[2]?.users?.profile_icon}}</div>
                    <div class="text-white text-[24px] font-semibold text-center max-w-[200px] text-ellipsis overflow-hidden">
                        {{rankedUsers[2]?.users?.nickname}}</div>
                </div>
                <div class="w-[250px] flex place-content-center items-end leading-[38px] podium-copper h-[25vh] rounded-t-lg bg-orange-900">
                    <div class="text-live_secondary font-bold text-[70px] rounded-lg px-2 w-fit mx-auto text-center" [ngClass]="{'!text-[50px]':rankedUsers[2]?.score > 999,'!text-[30px]':rankedUsers[2]?.score > 99999}">
                        {{rankedUsers[2]?.score}}</div>
                </div>
            </div>}
        </div>
        <img src="./assets/logo.png" class="mx-auto h-[100px] animation-start-quiz-logo">
        }
        @if(showCurrentTempRank){<div class="max-h-[60vh] overflow-y-scroll hide-bar">
            @if(showCorrectAnswer){<div (click)="nextQuestion()"
                class="text-live_primary mx-auto font-semibold mt-1 w-fit cursor-pointer text-center px-8 text-[24px] rounded-full py-2 bg-live_secondary shadow-inner">
                {{quiz.questions.length > (currentStep+1) ? t('nextQuestion') : t('terminateQuiz')}}</div>}
    
            @for (user of endQuiz ?rankedUsers.slice(3) : rankedUsers;
            track $index) {
            <div
                class="px-2 mt-5 mx-auto flex place-content-center max-w-[500px] rounded-full border-black bg-white bg-opacity-25 backdrop-blur-[50px]">
                <div class="flex gap-2 items-center place-content-center w-full mx-auto">
                    <div class="text-white font-bold text-[40px] pl-5">{{user.position}}</div>
                    <div class="text-[40px]">{{user?.users?.profile_icon}}</div>
                    <div class="text-white font-bold text-[24px]">{{user?.users?.nickname}}</div>
                    <div class="text-white font-bold text-[24px]">{{user?.score}}</div>
                </div>
            </div>
            }
        </div>}
        @if(endQuiz && showCompleteRank){
        <div class="max-h-[calc(100svh-140px)] overflow-y-scroll overflow-x-hidden custom-scrollbar-rank mt-10 w-[100%]">
            <div class="flex gap-5 place-content-start flex-wrap">
                @for (user of endQuiz ?rankedUsers : rankedUsers;
                track $index) {
                <app-user-rank class="h-[70px]" [position]="user.position" [icon]="user?.users?.profile_icon"
                    [nickname]="user?.users?.nickname" [score]="user?.score"></app-user-rank>
                }
            </div>
        </div>
        }
        @if(endQuiz && !showCompleteRank){
    
        <div class="max-h-[40vh] open-rank overflow-y-hidden hide-bar mx-auto w-[790px] gap-y-5 gap-5 flex flex-wrap">
            @for (user of endQuiz ?rankedUsers.slice(3,10) : rankedUsers;
            track $index) {
            <app-user-rank customClass="!w-[385px]" [position]="user.position" [icon]="user?.users?.profile_icon"
                [nickname]="user?.users?.nickname" [score]="user?.score"></app-user-rank>
            }
            @if(rankedUsers.length > 10){
            <app-user-rank customClass="!w-[385px]" [last]="true" [position]="rankedUsers[rankedUsers.length -1].position"
                [icon]="rankedUsers[rankedUsers.length -1]?.users?.profile_icon"
                [nickname]="rankedUsers[rankedUsers.length -1]?.users?.nickname"
                [score]="rankedUsers[rankedUsers.length -1]?.score"></app-user-rank>
            }
        </div>}
        @if(endQuiz){
        <div (click)="showCompleteRank = !showCompleteRank" class="fixed cursor-pointer z-[9999] top-4 right-4">
            <svg width="50px" height="50px" fill="white" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
                <path
                    d="M353.8 118.1L330.2 70.3C326.3 62 314.1 61.7 309.8 70.3L286.2 118.1L233.9 125.6C224.6 127 220.6 138.5 227.5 145.4L265.5 182.4L256.5 234.5C255.1 243.8 264.7 251 273.3 246.7L320.2 221.9L366.8 246.3C375.4 250.6 385.1 243.4 383.6 234.1L374.6 182L412.6 145.4C419.4 138.6 415.5 127.1 406.2 125.6L353.9 118.1zM288 320C261.5 320 240 341.5 240 368L240 528C240 554.5 261.5 576 288 576L352 576C378.5 576 400 554.5 400 528L400 368C400 341.5 378.5 320 352 320L288 320zM80 384C53.5 384 32 405.5 32 432L32 528C32 554.5 53.5 576 80 576L144 576C170.5 576 192 554.5 192 528L192 432C192 405.5 170.5 384 144 384L80 384zM448 496L448 528C448 554.5 469.5 576 496 576L560 576C586.5 576 608 554.5 608 528L608 496C608 469.5 586.5 448 560 448L496 448C469.5 448 448 469.5 448 496z" />
            </svg>
        </div>
        }
    </div>
    }
    <div class="fixed right-6 bottom-16 z-10">
        <div class="w-[20px] ml-auto mr-20 select-none relative top-[-30px]" id="fountain"></div>
    </div>
</div>